// Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule, PublicEventsService, StsConfigLoader } from 'angular-auth-oidc-client';
// Module
import { AppInformationService, CoreModule, HttpCoreModule } from '@cv-invision/core';
import { AppRouteModule } from './app-routing.module';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { ChatBotModule } from '@cv-invision/cv.invision-views.ux';
import 'brace/mode/json';
// Component
import { AppComponent } from './app.component';
import { AuthFromKeyComponent } from './components/auth-from-key/auth-from-key.component';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
// Telemetry
import {
	IntelligenceEndpointResolver,
	IntelligenceIdResolver,
	IntelligenceStorageWrapper,
	IntelligenceIsActiveResolver
} from '@cv-invision/core';
// Services
import { AppService, loadAppConfig, ConfigService, loadAppConfigService } from '@cv-invision/core';
// Required!!!!!
import { QcAppService } from './config/service/qc-app.service';
import { AppLoaderFactory, ConfigQCService } from './config/service/config-qc.service';
import { AppConfigBootstrapModel } from './models/app-config-bootstrap.model';
import { Store } from '@ngxs/store';

@NgModule({
	declarations: [
		AppComponent,
		AuthFromKeyComponent
	],
	imports: [
		CoreModule,
		ChatBotModule,
		AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: AppLoaderFactory,
				deps: [Store, ConfigQCService]
            }
        }),
		HttpCoreModule,
		BrowserModule,
		AppRouteModule,
		BrowserAnimationsModule,
		CvComponentLibraryModule,
		NgxsStoragePluginModule.forRoot()
	],
	providers: [
		ConfigQCService,
		{
			provide: ConfigService,
			useFactory: loadAppConfigService,
			deps: [ConfigQCService]
		},
		QcAppService,
		{
			provide: AppService,
			useFactory: loadAppConfig,
			deps: [QcAppService]
		},
		{provide: 'TelemetryEndpointResolver', useClass: IntelligenceEndpointResolver},
		{provide: 'TelemetryIdResolver', useClass: IntelligenceIdResolver},
		{provide: 'TelemetryStorage', useClass: IntelligenceStorageWrapper},
		{provide: 'TelemetryIsActiveResolver', useClass: IntelligenceIsActiveResolver}
	],
	bootstrap: [AppComponent]
})
export class AppModule extends AppConfigBootstrapModel {
	constructor(
		protected readonly eventService: PublicEventsService,
		protected appInfo: AppInformationService,
		protected store: Store
	) {
		super(eventService, appInfo, store);
	}
}
